import React from "react";
import { Switch, Route } from "react-router-dom";
import Video from "./Index";

export default () => (
  <Switch>
    <Route exact path="/honeytoastlivestream" component={Video} />
  </Switch>
);
